<template>
  <div
    :class="cruiseType + '-search-container cruise-search-bar-container'"
    ref="SearchBarContainer"
    :data-type="cruiseType"
  >
    <div class="search_container" :id="cruiseType + '_search'">
      <div
        class="chosen-wrap departureCodes"
        id="dep"
        data-key="DepartureCode"
        @click="showForm('departure')"
      >
        <div
          class="chosen-container chosen-container-single"
          style="width: 100%"
        >
          <div class="chosen-single" tabindex="-1">
            <div class="chosen-bind">
              选择出发港<span
                class="badge"
                v-show="selectedDeparturesCount > 0"
                >{{ selectedDeparturesCount }}</span
              >
            </div>
            <div class="chosen-content">
              <span
                style="max-width: 225px"
                :class="{ 'item-empty': selectedDepartures == '请选择' }"
              >
                {{ selectedDepartures }}
              </span>
              <b class="search-select-arrow" aria-hidden="true"></b>
            </div>
          </div>
        </div>
      </div>

      <div
        class="chosen-wrap sailDates"
        id="month"
        data-key="SailDate"
        @click="showForm('sailDate')"
      >
        <div
          class="chosen-container chosen-container-single"
          style="width: 100%"
        >
          <div class="chosen-single" tabindex="-1">
            <div class="chosen-bind">
              选择出发时间<span
                class="badge"
                v-show="selectedSailDatesCount > 0"
                >{{ selectedSailDatesCount }}</span
              >
            </div>
            <div class="chosen-content">
              <span
                style="max-width: 180px"
                :class="{ 'item-empty': selectedSailDates == '请选择' }"
                >{{ selectedSailDates }}</span
              >
              <img
                src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/icon-date-1.jpg"
              />
            </div>
          </div>
        </div>
      </div>

      <div
        class="chosen-wrap destinationCodes"
        id="des"
        data-key="DestinationCode"
        @click="showForm('destination')"
      >
        <div
          class="chosen-container chosen-container-single"
          style="width: 100%"
        >
          <div class="chosen-single" tabindex="-1">
            <div class="chosen-bind">
              选择目的地<span
                class="badge"
                v-show="selectDestinationsCount > 0"
                >{{ selectDestinationsCount }}</span
              >
            </div>
            <div class="chosen-content">
              <span
                style="max-width: 412px"
                :class="{ 'item-empty': selectDestinations == '请选择' }"
                >{{ selectDestinations }}</span
              >
              <b class="search-select-arrow" aria-hidden="true"></b>
            </div>
          </div>
        </div>
      </div>
      <div class="" id="searchCruiseH">
        <button class="search_button" @click="onSearchBtnClick()">
          航线搜索
        </button>
      </div>
    </div>

    <div class="search_form" ref="SearchBarForm" :style="formStyle()">
      <!-- 出发地 -->
      <DepartureForm
        :cruiseType="cruiseType"
        :departures="getDepartures()"
        :departureGroups="departureGroups"
        :isShow="componentShow == 'departure'"
      />
      <SailDateForm
        :cruiseType="cruiseType"
        :isShow="componentShow == 'sailDate'"
      />
      <DestinationForm
        :cruiseType="cruiseType"
        :destinations="destinations"
        :isShow="componentShow == 'destination'"
      />
    </div>

    <div
      class="tranBg"
      v-if="componentShow && componentShow.length > 0"
      @click="componentShow = ''"
    ></div>
    <div v-else class="f-dn"></div>
  </div>
</template>

<script>
const DepartureForm = () => import("@/components/SearchBar/DepartureForm");
const SailDateForm = () => import("@/components/SearchBar/SailDateForm");
const DestinationForm = () => import("@/components/SearchBar/DestinationForm");
import { gioTracking } from "@/utilities/tools";
export default {
  name: "SearchBarContainer",
  components: {
    DepartureForm,
    SailDateForm,
    DestinationForm,
  },
  props: {
    cruiseType: {
      type: String,
      default: function () {
        return "hp";
      },
    },
    cruiseFilters: {
      type: Array,
      default: function () {
        return [];
      },
    },
    rowCruiseSearchHandler: {
      type: Function,
    },
  },
  data() {
    return {
      componentShow: "",
    };
  },
  methods: {
    showForm(component) {
      if (this.componentShow == component) {
        this.componentShow = "";
      } else {
        this.componentShow = component;
        this.$nextTick(() => {
          this.autoScrollHandler();
        });
      }
    },
    // 展开搜索框自动滚动
    autoScrollHandler() {
      const windowHeight = window.innerHeight;
      const searchHeight =
        this.$refs.SearchBarContainer.clientHeight +
        this.$refs.SearchBarForm.clientHeight;
      if (windowHeight < searchHeight) {
        // 如果屏幕高度小于搜索框展开高度的话，直接滚到搜索框的位置
        let top = this.$refs.SearchBarContainer.getBoundingClientRect().top;
        window.scroll({
          top: top,
          behavior: "smooth",
        });
      } else {
        // 判断是否已经显示完全，即需不需要滚动
        var currentScrollTop = window.scrollY;
        var offsetHeight = this.$refs.SearchBarContainer.getBoundingClientRect()
          .top;

        if (searchHeight + offsetHeight > windowHeight + currentScrollTop) {
          // 滚动到显示完全
          let top = offsetHeight - (windowHeight - searchHeight) / 2;
          window.scroll({
            top: top,
            behavior: "smooth",
          });
        }
      }
    },
    formStyle() {
      if (this.componentShow == "sailDate") {
        return {
          width: "741px",
          left: "289px",
        };
      } else if (this.componentShow == "departure" && this.cruiseType == "hp") {
        return {
          width: "290px",
          left: "0",
        };
      } else {
        return {
          width: "100%",
          left: "0px",
        };
      }
    },
    getDepartures() {
      const platform = this.cruiseType == "hp" ? "HP" : "TUI";
      return this.cruiseFilters.filter(function (filter) {
        return (
          filter.platform == platform &&
          filter.category == "DEPARTURE" &&
          filter.active
        );
      });
    },
    onSearchBtnClick() {
      const filters = this.$store.state.cruise.filterRequest[this.cruiseType];
      let url = "/Rccl.Cruise/CruiseSearch/Search";
      if (this.cruiseType == "row") {
        // url = process.env.VUE_APP_TUI_URL + "/Cruise/Search";
        url = "/Rccl.Cruise/CruiseSearch/SearchRow";
      }
      let query = [];
      if (filters.departures.length > 0) {
        query.push(
          "departureCodes=" +
            filters.departures.map((item) => item.code).join(",")
        );
      }
      if (filters.sailDates.length > 0) {
        query.push(
          "sailDates=" + filters.sailDates.map((item) => item.code).join(",")
        );
      }
      if (filters.destinations.length > 0) {
        query.push(
          "destinationCodes=" +
            filters.destinations.map((item) => item.code).join(",")
        );
      }
      if (query.length > 0) {
        url += "?" + query.join("&");
      }

			gioTracking('track', 'evt_ButtonClicked', {
        "btnType": "mainSch"
      })
      
      this.$router.push(url);
      
    },
  },
  computed: {
    departureGroups() {
      let groups = [];
      this.getDepartures().forEach((departure) => {
        if (!groups.includes(departure.cruiseFilterGroupName))
          groups.push(departure.cruiseFilterGroupName);
      });
      return groups;
    },
    destinations() {
      const platform = this.cruiseType == "hp" ? "HP" : "TUI";
      return this.cruiseFilters.filter(function (filter) {
        return (
          filter.platform == platform &&
          filter.category == "DESTINATION" &&
          filter.active
        );
      });
    },
    selectedDepartures() {
      const departures = this.$store.state.cruise.filterRequest[this.cruiseType]
        .departures;
      let departureNames = [];
      departures.forEach((item) => {
        departureNames.push(item.name);
      });
      if (departureNames.length == 0) {
        return "请选择";
      }
      return departureNames.join("、");
    },
    selectedDeparturesCount() {
      const departures = this.$store.state.cruise.filterRequest[this.cruiseType]
        .departures;
      return departures.length;
    },
    selectedSailDates() {
      const sailDates = this.$store.state.cruise.filterRequest[this.cruiseType]
        .sailDates;
      let sailDateList = [];
      sailDates.forEach((item) => {
        if (item.name && item.name.length > 0) {
          sailDateList.push(item.name.replace(/-/g, "/"));
        }
      });
      if (sailDateList.length == 0) {
        return "请选择";
      }
      return sailDateList.join("、");
    },
    selectedSailDatesCount() {
      const sailDates = this.$store.state.cruise.filterRequest[this.cruiseType]
        .sailDates;
      return sailDates.length;
    },
    selectDestinations() {
      const destinations = this.$store.state.cruise.filterRequest[
        this.cruiseType
      ].destinations;
      let destinationNames = [];
      destinations.forEach((item) => {
        destinationNames.push(item.name);
      });
      if (destinationNames.length == 0) {
        return "请选择";
      }
      return destinationNames.join("、");
    },
    selectDestinationsCount() {
      const destinations = this.$store.state.cruise.filterRequest[
        this.cruiseType
      ].destinations;
      return destinations.length;
    },
  },
};
</script>

<style lang="less" scoped>
.tranBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 9;
}
</style>
